define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "../../themes", "../../utils"], function (_exports, _taggedTemplateLiteralLoose2, _react, _styledComponents, _themes, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var _templateObject, _templateObject2, _templateObject3;

  var BulletsAndTextStyled = _styledComponents.default.div.withConfig({
    displayName: "BulletsAndText__BulletsAndTextStyled",
    componentId: "sc-17l1mwr-0"
  })(["display:flex;flex-direction:column;flex:1;margin-bottom:16px;text-align:center;+ div{margin-left:8px;}", ""], _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex: 1;\n    flex-direction: column;\n    justify-content: center;\n    margin: 0px;\n  "]))));

  var LegendStyle = _styledComponents.default.span.withConfig({
    displayName: "BulletsAndText__LegendStyle",
    componentId: "sc-17l1mwr-1"
  })(["font-size:1.3em;margin:8px 0 0;"]);

  var Bullets = _styledComponents.default.div.withConfig({
    displayName: "BulletsAndText__Bullets",
    componentId: "sc-17l1mwr-2"
  })(["align-items:center;display:flex;flex:1;justify-content:center;width:100%;", ""], _themes.device.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    justify-content: center;\n  "]))));

  var BulletsText = _styledComponents.default.div.withConfig({
    displayName: "BulletsAndText__BulletsText",
    componentId: "sc-17l1mwr-3"
  })(["display:flex;flex:1;flex-direction:column;justify-content:space-between;width:100%;", ""], _themes.device.desktop(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    justify-content: center;\n  "]))));

  var BulletItem = _styledComponents.default.span.withConfig({
    displayName: "BulletsAndText__BulletItem",
    componentId: "sc-17l1mwr-4"
  })(["", ";background-color:", ";border-radius:50%;display:inline-block;@media print{background-color:", ";-webkit-print-color-adjust:exact;}+ span{margin-left:8px;}", ""], (0, _themes.size)(8), function (_ref) {
    var theme = _ref.theme;
    return theme.colors.orange;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.darkGray;
  }, function (_ref3) {
    var active = _ref3.active;
    return active && (0, _styledComponents.css)(["background-color:", ";~ span{background-color:", ";}@media print{background-color:", ";-webkit-print-color-adjust:exact;~ span{background-color:", ";-webkit-print-color-adjust:exact;}}"], function (_ref4) {
      var theme = _ref4.theme;
      return theme.colors.gray;
    }, function (_ref5) {
      var theme = _ref5.theme;
      return theme.colors.gray;
    }, function (_ref6) {
      var theme = _ref6.theme;
      return theme.colors.gray;
    }, function (_ref7) {
      var theme = _ref7.theme;
      return theme.colors.gray;
    });
  });

  var nivelValue = function nivelValue(value) {
    var itens = [];

    for (var index = 1; index < 5; index++) {
      itens.push( /*#__PURE__*/_react.default.createElement(BulletItem, {
        active: index === value,
        key: (0, _utils.uniqueId)()
      }));
    }

    return itens;
  };

  var BulletsAndText = function BulletsAndText(_ref8) {
    var label = _ref8.label,
        value = _ref8.value,
        level = _ref8.level;
    return /*#__PURE__*/_react.default.createElement(BulletsAndTextStyled, {
      key: (0, _utils.uniqueId)()
    }, /*#__PURE__*/_react.default.createElement("em", null, label), /*#__PURE__*/_react.default.createElement(Bullets, null, nivelValue(value)), /*#__PURE__*/_react.default.createElement(BulletsText, null, /*#__PURE__*/_react.default.createElement(LegendStyle, null, level)));
  };

  var _default = BulletsAndText;
  _exports.default = _default;
});